export const responseStatus = {
  unauthorized: 401,
  ok: 200,
} as const;
